/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobTitleField
 */
export interface JobTitleField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof JobTitleField
     */
    value: string;
}

/**
 * Check if a given object implements the JobTitleField interface.
 */
export function instanceOfJobTitleField(value: object): value is JobTitleField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function JobTitleFieldFromJSON(json: any): JobTitleField {
    return JobTitleFieldFromJSONTyped(json, false);
}

export function JobTitleFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobTitleField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function JobTitleFieldToJSON(value?: JobTitleField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

